<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
    <v-flex xs12 class="inline-block px-2">
      <v-text-field hide-details :label="$t('Admin.AdminFleet.Form.Libelle')" v-model="fle_libelle" />
      <v-select
        hide-details
        :items="enseignes"
        item-text="ENS_LIBELLE"
        item-value="ENS_ID"
        :label="$t('Admin.AdminFleet.Form.Company')"
        v-model="ens_id"
      ></v-select>
      <v-autocomplete
        small-chips
        deletable-chips
        multiple
        clearable
        :items="missions"
        item-text="MIS_LIBELLE"
        item-value="MIS_ID"
        :label="$t('Admin.AdminFleet.Form.Missions')"
        v-model="mission_ids"
      ></v-autocomplete>
      <!-- <v-switch hide-details :disabled="true" v-model="fle_actif" :label="$t('Admin.AdminFleet.Form.MisActif')"></v-switch> -->
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne'
import { isFleetTypeAllowed } from '@/utils/tenantModules'

@Component({
  name: 'AdminAdminFleetForm',
})
export default class AdminAdminFleetForm extends Vue {
  created() {
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
    this.$store.myActions.ADMINMISSION_ENSURE_LIST()
  }

  // BLF037 — enseignes où le type de la flotte est autorisé (sinon la flotte disparaîtrait à
  // l'enregistrement) ; l'enseigne actuelle de la flotte reste proposée.
  get enseignes() {
    return this.$store.myGetters.enseignes.filter(
      (e: AloDbEnseigne) => e.ENS_ID === this.modified?.ENS_ID || isFleetTypeAllowed(e.config, this.modified?.FLE_TYP),
    )
  }

  get missions() {
    return this.$store.myGetters.adminMissions
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmAdminFleet
  }

  get fle_libelle() {
    return this.modified.FLE_LIBELLE!
  }
  set fle_libelle(value: string) {
    this.$store.myActions.ADMINFLEET_UPDATE_MODIFIED_ADM({
      FLE_LIBELLE: value,
    })
  }

  get ens_id() {
    return this.modified.ENS_ID!
  }
  set ens_id(value: number) {
    this.$store.myActions.ADMINFLEET_UPDATE_MODIFIED_ADM({
      ENS_ID: value,
    })
  }

  get fle_actif() {
    return true //this.modified.FLE_ACTIF_ON
  }

  get mission_ids() {
    return this.modified.MISSION_IDS
  }

  set mission_ids(value: Array<number>) {
    this.$store.myActions.ADMINFLEET_UPDATE_MODIFIED_ADM({
      MISSION_IDS: value,
    })
  }
}
</script>
